export const namespaced = true;
export const state = {
    reservationDetailsDialog: {
        isOpen: false,
        reservationId: null,
        openTab: 'main'
    },
    itemDetailsDialog: {
        isOpen: false,
        itemId: null,
        reservationId: null,
        openTab: 'information'
    },
    createDialog: {
        isOpen: false,
        prefill: null
    },
    editItemDialog: {
        isOpen: false,
        item: null
    },
    cancelItemDialog: {
        isOpen: false,
        item: null
    },
    checkInResultDialog: {
        isOpen: false,
        item: null,
        checkinConfirmationSent: false
    },
    reservableInUseDialog: {
        isOpen: false,
        reservablesInUse: []
    },
    productDialog: {
        isOpen: false,
        productId: null,
        openTab: 'information'
    },
    productEditDialog: {
        isOpen: false,
        productId: null,
        openTab: 'general'
    }
};
export const mutations = {
    OPEN_DIALOG(state, reservationId) {
        state.reservationDetailsDialog.isOpen = true;
        state.reservationDetailsDialog.reservationId = reservationId;
    },
    CLOSE_DIALOG(state) {
        state.reservationDetailsDialog.isOpen = false;
    },
    SET_DIALOG_OPEN_TAB(state, val) {
        state.reservationDetailsDialog.openTab = val;
    },
    OPEN_ITEM_DIALOG(state, { itemId, reservationId }) {
        state.itemDetailsDialog.isOpen = true;
        state.itemDetailsDialog.itemId = itemId;
        state.itemDetailsDialog.reservationId = reservationId;
    },
    CLOSE_ITEM_DIALOG(state) {
        state.itemDetailsDialog.isOpen = false;
    },
    SET_ITEM_DIALOG_OPEN_TAB(state, val) {
        state.itemDetailsDialog.openTab = val;
    },
    OPEN_CREATE_DIALOG(state, prefill) {
        state.createDialog.isOpen = true;
        state.createDialog.prefill = prefill ?? null;
    },
    CLOSE_CREATE_DIALOG(state) {
        state.createDialog.isOpen = false;
        state.createDialog.prefill = null;
    },
    OPEN_EDIT_ITEM_DIALOG(state, item) {
        state.editItemDialog.isOpen = true;
        state.editItemDialog.item = item;
    },
    CLOSE_EDIT_ITEM_DIALOG(state) {
        state.editItemDialog.isOpen = false;
        state.editItemDialog.item = null;
    },
    OPEN_CANCEL_ITEM_DIALOG(state, item) {
        state.cancelItemDialog.isOpen = true;
        state.cancelItemDialog.item = item;
    },
    CLOSE_CANCEL_ITEM_DIALOG(state) {
        state.cancelItemDialog.isOpen = false;
        state.cancelItemDialog.item = null;
    },
    OPEN_CHECK_IN_RESULT_DIALOG(state, { item, checkinConfirmationSent }) {
        state.checkInResultDialog.isOpen = true;
        state.checkInResultDialog.item = item;
        state.checkInResultDialog.checkinConfirmationSent = checkinConfirmationSent;
    },
    CLOSE_CHECK_IN_RESULT_DIALOG(state) {
        state.checkInResultDialog.isOpen = false;
        state.checkInResultDialog.item = null;
        state.checkInResultDialog.checkinConfirmationSent = false;
    },
    OPEN_RESERVABLE_IN_USE_DIALOG(state, reservablesInUse) {
        state.reservableInUseDialog.isOpen = true;
        state.reservableInUseDialog.reservablesInUse = reservablesInUse;
    },
    CLOSE_RESERVABLE_IN_USE_DIALOG(state) {
        state.reservableInUseDialog.isOpen = false;
        state.reservableInUseDialog.reservablesInUse = [];
    },
    OPEN_PRODUCT_DIALOG(state, productId) {
        state.productDialog.isOpen = true;
        state.productDialog.productId = productId;
    },
    CLOSE_PRODUCT_DIALOG(state) {
        state.productDialog.isOpen = false;
    },
    SET_PRODUCT_DIALOG_OPEN_TAB(state, val) {
        state.productDialog.openTab = val;
    },
    OPEN_PRODUCT_EDIT_DIALOG(state, productId) {
        state.productEditDialog.isOpen = true;
        state.productEditDialog.productId = productId;
    },
    CLOSE_PRODUCT_EDIT_DIALOG(state) {
        state.productEditDialog.isOpen = false;
    },
    SET_PRODUCT_EDIT_DIALOG_OPEN_TAB(state, val) {
        state.productEditDialog.openTab = val;
    }
};
export const actions = {
    openDialogById({ commit }, { reservationId, startTab }) {
        commit('OPEN_DIALOG', reservationId);
        commit('SET_DIALOG_OPEN_TAB', startTab || 'main');
    },
    closeDialog({ commit }) {
        commit('CLOSE_DIALOG');
    },
    openItemDialog({ commit }, { itemId, reservationId, startTab }) {
        commit('OPEN_ITEM_DIALOG', { itemId, reservationId });
        commit('SET_ITEM_DIALOG_OPEN_TAB', startTab || 'information');
    },
    closeItemDialog({ commit }) {
        commit('CLOSE_ITEM_DIALOG');
    },
    openCreateDialog({ commit }, prefill) {
        commit('OPEN_CREATE_DIALOG', prefill ?? null);
    },
    closeCreateDialog({ commit }) {
        commit('CLOSE_CREATE_DIALOG');
    },
    openEditItemDialog({ commit }, item) {
        commit('OPEN_EDIT_ITEM_DIALOG', item);
    },
    closeEditItemDialog({ commit }) {
        commit('CLOSE_EDIT_ITEM_DIALOG');
    },
    openCancelItemDialog({ commit }, item) {
        commit('OPEN_CANCEL_ITEM_DIALOG', item);
    },
    closeCancelItemDialog({ commit }) {
        commit('CLOSE_CANCEL_ITEM_DIALOG');
    },
    openCheckInResultDialog({ commit }, payload) {
        commit('OPEN_CHECK_IN_RESULT_DIALOG', payload);
    },
    closeCheckInResultDialog({ commit }) {
        commit('CLOSE_CHECK_IN_RESULT_DIALOG');
    },
    openReservableInUseDialog({ commit }, reservablesInUse) {
        commit('OPEN_RESERVABLE_IN_USE_DIALOG', reservablesInUse);
    },
    closeReservableInUseDialog({ commit }) {
        commit('CLOSE_RESERVABLE_IN_USE_DIALOG');
    },
    openProductDialog({ commit }, { productId, startTab }) {
        commit('OPEN_PRODUCT_DIALOG', productId);
        commit('SET_PRODUCT_DIALOG_OPEN_TAB', startTab || 'information');
    },
    closeProductDialog({ commit }) {
        commit('CLOSE_PRODUCT_DIALOG');
    },
    /**
     * Öppnar redigeringsdialogen ovanpå översiktsdialogen. Är den redan öppen
     * för samma produkt byts bara flik, t.ex. från en länk i en konfigurationsvarning.
     */
    openProductEditDialog({ commit }, { productId, startTab }) {
        commit('OPEN_PRODUCT_EDIT_DIALOG', productId);
        commit('SET_PRODUCT_EDIT_DIALOG_OPEN_TAB', startTab || 'general');
    },
    closeProductEditDialog({ commit }) {
        commit('CLOSE_PRODUCT_EDIT_DIALOG');
    }
};
